<template>
  <div class="title">
    <h3 class="calc__title">Калькуляторы технического обслуживания</h3>
  </div>
  <div class="calc__text">
    <p class="calc__text--text">Рассчитайте примерную стоимость ТО. Окончательная стоимость будет известна после осмотра объекта </p>
    <p class="calc__text--text">Мы предоставим вам скидку на техническое обслуживание при цене от 10 000 ₽. Скидка динамическая от 5% до 20%</p>
  </div>

  <div class="calc__tabs">
    <button v-for="btn in btns" :key="btn.id" @click="setCurrent(btn.arr, btn.id), title(btn.title)" :ref="btn.ref"
      :class="{ active: currentBtn == btn.id }" class="calc__tab" v-html="btn.text"></button>
  </div>

  <div class="hardware">
    <CalcMain :hardware="current" :currentTitle="currentTitle" :tariff="tariff" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      current: getApsHardware(),
      currentBtn: 0,
      currentTitle: '',
      tariff: 0,

      // описание кнопок
      btns: [
        { id: 0, ref: 'button', arr: getApsHardware(), text: 'Пожар&shy;ная<br>сиг&shy;на&shy;ли&shy;за&shy;ция и СОУЭ', title: "Расчет стоимости технического обслуживания пожарной сигнализации и СОУЭ" },
        { id: 1, ref: 'button', arr: getOsHardware(), text: 'Охранная<br>сигна&shy;ли&shy;за&shy;ция', title: "Расчет стоимости технического обслуживания охранной сигнализации" },
        { id: 2, ref: 'button', arr: getSvnHardware(), text: 'Система<br>ви&shy;деонаб&shy;лю&shy;де&shy;ния', title: "Расчет стоимости технического обслуживания системы видеонаблюдения" },
        { id: 3, ref: 'button', arr: getSkudHardware(), text: 'Система кон&shy;тро&shy;ля дос&shy;ту&shy;па', title: "Расчет стоимости технического обслуживания системы контроля доступа" },

      ]

    }
  },
  created() {
    this.$store.dispatch("getDataFromDb")
      .then(() => {
        this.tariff = this.$store.state.tariff
      })
  },
  methods: {
    setCurrent(hardware, id) {
      // текущая кнопка - для присвоения класса active
      this.currentBtn = id
      this.current = hardware
    },
    title(title) {
      this.currentTitle = title
    }

  },
  computed: {

  },
  mounted() {
    // имитация клика на кнопку, иначе пропадает реактивность при первичной загрузке компонента CalcMain    
    this.$refs.button[0].click()
  }

}

// исходные данные
// hours - человекочасы, count - кол-во оборудования, max - максимаьное кол-во оборудования для инпутов, isActive - если true то инпут в фокусе и цвет букв Descr - красный
function getApsHardware() {
  let arr = [
    { id: 0, descr: 'Извещатель дымовой пожарный', hours: 0.46, count: null, max: 10000, isActive: false },
    { id: 1, descr: 'Извещатель пожарный тепловой', hours: 0.24, count: null, max: 10000, isActive: false },
    { id: 2, descr: 'Извещатель пожарный ручной', hours: 0.14, count: null, max: 500, isActive: false },
    { id: 3, descr: 'Извещатель пожарный дымовой линейный', hours: 0.32, count: null, max: 500, isActive: false },
    { id: 4, descr: 'Извещатель пожарный пламени', hours: 0.28, count: null, max: 500, isActive: false },
    { id: 5, descr: 'Прибор приемно-контрольный', hours: 24.36, count: null, max: 100, isActive: false },
    { id: 6, descr: 'Блок индикации', hours: 0.48, count: null, max: 50, isActive: false },
    { id: 7, descr: 'Оповещатель звуковой', hours: 0.19, count: null, max: 500, isActive: false },
    { id: 8, descr: 'Оповещатель светозвуковой', hours: 0.19, count: null, max: 500, isActive: false },
    { id: 9, descr: 'Оповещатель световой', hours: 0.17, count: null, max: 500, isActive: false },
    { id: 10, descr: 'Пульт контроля и управления', hours: 0.44, count: null, max: 10, isActive: false },
    { id: 11, descr: 'Блоки бесперебойного электропитания 12В (с аккумуляторной батареей)', hours: 0.76, count: null, max: 100, isActive: false },
  ]
  return arr
}

function getOsHardware() {
  let arr = [
    { id: 0, descr: 'Извещатель охранный инфракрасный', hours: 0.14, count: null, max: 5000, isActive: false },
    { id: 1, descr: 'Извещатель охранный магнитоконтактный', hours: 0.28, count: null, max: 5000, isActive: false },
    { id: 2, descr: 'Извещатель охранный поверхностный звуковой', hours: 0.14, count: null, max: 5000, isActive: false },
    { id: 3, descr: 'Извещатель емкостной', hours: 0.62, count: null, max: 5000, isActive: false },
    { id: 4, descr: 'Извещатель вибрационный', hours: 0.56, count: null, max: 5000, isActive: false },
    { id: 5, descr: 'Извещатель охранный линейный оптико-электронный', hours: 0.34, count: null, max: 5000, isActive: false },
    { id: 6, descr: 'Извещатель охранный поверхностный', hours: 0.30, count: null, max: 5000, isActive: false },
    { id: 7, descr: 'Извещатель охранный проводно-волновый линейный', hours: 0.78, count: null, max: 500, isActive: false },
    { id: 8, descr: 'Извещатель охранный совмещенный (ИК+ДРС, ИК+СВЧ)', hours: 0.32, count: null, max: 5000, isActive: false },
    { id: 9, descr: 'Тревожная кнопка', hours: 0.38, count: null, max: 50, isActive: false },
    { id: 10, descr: 'Прибор приемно-контрольный', hours: 24.36, count: null, max: 100, isActive: false },
    { id: 11, descr: 'Блок индикации', hours: 0.48, count: null, max: 50, isActive: false },
    { id: 12, descr: 'Оповещатель звуковой', hours: 0.19, count: null, max: 500, isActive: false },
    { id: 13, descr: 'Пульт контроля и управления', hours: 0.44, count: null, max: 10, isActive: false },
    { id: 14, descr: 'Блоки бесперебойного электропитания 12В (с аккумуляторной батареей)', hours: 0.76, count: null, max: 100, isActive: false },
  ]
  return arr
}

function getSvnHardware() {
  let arr = [
    { id: 0, descr: 'Видеокамера аналоговая для установки внутри помещений', hours: 5.36, count: null, max: 1000, isActive: false },
    { id: 1, descr: 'Видеокамера аналоговая в уличном исполнении', hours: 2.72, count: null, max: 1000, isActive: false },
    { id: 2, descr: 'IP-видеокамера для установки внутри помещений', hours: 0.60, count: null, max: 1000, isActive: false },
    { id: 3, descr: 'IP-видеокамера  в уличном исполнении', hours: 4.56, count: null, max: 1000, isActive: false },
    { id: 4, descr: 'Видеокамера роботизированная поворотная', hours: 6.48, count: null, max: 1000, isActive: false },
    { id: 5, descr: 'IP-видеокамера с поворотной платформой и трансфокатором', hours: 5.36, count: null, max: 1000, isActive: false },
    { id: 6, descr: 'Пульт управления роботизированной видеокамерой', hours: 0.92, count: null, max: 100, isActive: false },
    { id: 7, descr: 'Видеорегистратор', hours: 5.94, count: null, max: 50, isActive: false },
    { id: 8, descr: 'Видеосервер (специализированное ПО)', hours: 11.88, count: null, max: 50, isActive: false },
    { id: 9, descr: 'Монитор', hours: 0.26, count: null, max: 50, isActive: false },
    { id: 10, descr: 'Коммутатор ЛВС', hours: 0.44, count: null, max: 50, isActive: false },
    { id: 11, descr: 'Приёмо/передатчик видеосигнала, преобразователи', hours: 0.34, count: null, max: 1000, isActive: false },
    { id: 12, descr: 'Устройство грозозащиты', hours: 0.14, count: null, max: 1000, isActive: false },
    { id: 13, descr: 'Блоки бесперебойного электропитания 12В (с аккумуляторной батареей)', hours: 0.76, count: null, max: 100, isActive: false },
  ]
  return arr
}

function getSkudHardware() {
  let arr = [
    { id: 0, descr: 'Сервер СКУД (специализированное ПО)', hours: 9.6, count: null, max: 50, isActive: false },
    { id: 1, descr: 'Контроллер доступа сетевой (для двери, шлагбаума, турникета)', hours: 1.24, count: null, max: 500, isActive: false },
    { id: 2, descr: 'Контроллер доступа автономный', hours: 1.26, count: null, max: 500, isActive: false },
    { id: 3, descr: 'АРМ СКУД (специализированное ПО)', hours: 5.88, count: null, max: 50, isActive: false },
    { id: 4, descr: 'Доводчик дверной', hours: 0.84, count: null, max: 500, isActive: false },
    { id: 5, descr: 'Замок электромеханический, защёлка', hours: 1.36, count: null, max: 500, isActive: false },
    { id: 6, descr: 'Замок электромагнитный', hours: 0.68, count: null, max: 500, isActive: false },
    { id: 7, descr: 'Шлагбаум', hours: 7.14, count: null, max: 50, isActive: false },
    { id: 8, descr: 'Металлодетектор', hours: 1.88, count: null, max: 50, isActive: false },
    { id: 9, descr: 'Турникет', hours: 4.76, count: null, max: 50, isActive: false },
    { id: 10, descr: 'Считыватель БСК', hours: 0.19, count: null, max: 1000, isActive: false },
    { id: 11, descr: 'Считыватель биометрический', hours: 0.74, count: null, max: 1000, isActive: false },
    { id: 12, descr: 'Источник бесперебойного питания 220В', hours: 0.28, count: null, max: 50, isActive: false },
    { id: 13, descr: 'Датчик магнито-контактный', hours: 0.16, count: null, max: 500, isActive: false },
    { id: 14, descr: 'Монитор (для АРМ, видеодомофона)', hours: 0.26, count: null, max: 500, isActive: false },
    { id: 15, descr: 'Коммутатор ЛВС', hours: 0.44, count: null, max: 50, isActive: false },
    { id: 16, descr: 'Видеодомофон (вызывная панель)', hours: 0.76, count: null, max: 500, isActive: false },
    { id: 17, descr: 'Блоки бесперебойного электропитания 12В (с аккумуляторной батареей)', hours: 0.76, count: null, max: 100, isActive: false },
  ]
  return arr
}




</script>

<style lang="scss">
#app3-to {
  font-family: Gilroy, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
 
  max-width: 820px;
  width: 100%;
  margin: 0px auto; 
  margin-top: 60px;
}

.title {
  // max-width: 620px;
  width: 100%;
  margin: 0px auto; 
  // margin-top: 50px;
  // margin-bottom: 30px;
}

.active {
  background-color: red !important;
  ;
  transition: 0.3s;
  color: white;
}

.calc__tabs {
  // max-width: 620px;
  width: 100%;
  display: flex;
  // gap: 5px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  border-bottom: 4px solid #e21414;
  margin-bottom: 30px;
}
.calc__text{
  // max-width: 620px;
  width: 100%;
  margin: 20px auto;
}

.calc__tab {
  width: 25%;
  border: 0;
  background-color: rgb(206, 206, 206);
  min-height: 85px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.calc__title {
  text-align: left;
  margin-bottom: 30px;
}
.hardware{
  max-width: 620px;
  margin: 0 auto;
}
.calc__text--text{
  text-align: left;
}
</style>
